import type { ApiResponse } from "@/lib/api/types";

/**
 * Checks whether an account exists for the provided email.
 * Throws when the validate-email API reports an operational error.
 */
export async function validateEmailExists(email: string): Promise<boolean> {
  const response = await fetch("/api/auth/validate-email", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email }),
  });

  const json = (await response.json()) as ApiResponse<{ exists: boolean }>;

  if (!json.success || !json.data) {
    throw new Error(json.error?.message ?? "Unable to validate email");
  }

  return Boolean(json.data.exists);
}
